<div class="container zci-margin-top c11n-space-stack-10x c11n-space--force">
    <div class="col-xs-12 col-sm-12 col-md-8 col-xl-6 col-xxl-5 mx-auto">
        <div class="c11n-space-stack-3x d-flex justify-content-center">
            <img src="../../../../assets/phone-actions-question.svg" alt="" />
        </div>

        <h1 class="c11n-text-xl-headline c11n-space-stack-3x" data-cy="page-title">
            {{ content.technical_difficulties_API_error.heading }}
        </h1>
        <p
            class="c11n-text-md-normal c11n-space-stack-6x error-text"
            [innerHtml]="errDescription"
        ></p>
        <a
            c11n-link
            [href]="environment.ACCOUNT_SETTINGS_URL"
            variant="primary-reinforced"
            (click)="trackReturnToProfileAndAccountSettingsLink()"
            >{{
                content.add_user.zciTechnicalDifficultiesCallErrorMessage
                    .navReturnProfileAccountSettings
            }}</a
        >
    </div>
</div>
